import { Row, Col } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { trellisPalette } from "./analytics/palettes";
import { useAppSelector } from "redux/hooks";
import { Link } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import { apiClient } from "../../zodios/client";
import { useQuery } from "@tanstack/react-query";

const useSpApiCredentialCheck = (
  params: Parameters<typeof apiClient.checkSpApiCredential>[0]["queries"],
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: ["spApiCredentialCheck", params],
    queryFn: async () => await apiClient.checkSpApiCredential({ queries: params }),
    retry: false,
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });

const SpApiTokenExpirationBanner = () => {
  const [isSpApiBannerDismissed, setIsSpApiBannerDismissed] = useLocalStorage(
    "dismiss_sp_api_credential_expiration_banner",
    false,
  );
  const onboardData = useAppSelector((state) => state.amz_onboard);
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);

  const isSpApiConnected = [
    onboardData.amazon_spapi_access,
    onboardData.eu_amazon_spapi_access,
    onboardData.fe_amazon_spapi_access,
  ].includes("connected");

  const credentialCheckQuery = useSpApiCredentialCheck({ marketplace: marketPlace }, { enabled: isSpApiConnected });
  const showBanner =
    !isSpApiBannerDismissed && (credentialCheckQuery.data?.sp_api_fawcett_credential_disabled ?? false);

  if (showBanner) {
    return (
      <Row>
        <Col
          className="text-center p-4 fs-standard position-relative"
          style={{
            borderBottom: "1px solid #dcdadd",
            backgroundColor: trellisPalette[3],
          }}
        >
          <Link to="/user/amzsummary" className="text-white text-decoration-none px-2">
            Your organization's Amazon Selling Partner API tokens are now expired. Please reauthorize by visiting the{" "}
            <span style={{ textDecoration: "underline" }}>Amazon Connect</span> page to ensure your account's historical
            data is kept up to date.
          </Link>
          <button
            style={{
              position: "absolute",
              right: "20px",
              top: "12px",
              border: "none",
              backgroundColor: "inherit",
              cursor: "pointer",
            }}
            onClick={() => {
              setIsSpApiBannerDismissed(true);
            }}
          >
            <FaTimes size={15} style={{ color: "white" }} />
          </button>
        </Col>
      </Row>
    );
  }

  return null;
};

export default SpApiTokenExpirationBanner;
